import React, { Component } from 'react';
import { heights, widths, fonts, colors } from './../styles/theme.json';
import AnimateOnMount from './AnimateOnMount';
import '../styles/_social-share.scss';

export default class SocialShare extends Component {

  constructor(props) {
    super(props);
    this.image = null;
    this.description = '';
    let align = 'center';
    this.state = {
      showLinks: false,
      timeoutId: null
    };
    if (props.align) {
      align = props.align;
    };
    this.ulStyle = {
      textAlign: align
    };
    this.toggleLinks = this.toggleLinks.bind(this);
    this.toggleClick = this.toggleClick.bind(this);
    
  }

  toggleLinks() {
    clearTimeout(this.state.intervalId);    
    this.setState({
      showLinks: !this.state.showLinks
    }); 
  };

  toggleClick() {
    if (this.state.showLinks == false) {
      const timeoutId = setTimeout(this.toggleLinks, 10000);
      this.setState({ timeoutId: timeoutId });
    }
    this.toggleLinks();
  };

  componentWillUnmount() {
    clearTimeout(this.state.intervalId);
  }

  componentDidMount() {
    let t = this;
    if (this.props.Meta.image) {
      t.image = t.props.Meta.image;
    };
    if (this.props.Meta.title) {
      t.description += t.props.Meta.title + ' | ';
    }
    if (this.props.Meta.description) {
      t.description += t.props.Meta.description;
    }
    this.description = encodeURIComponent(this.description);
  }

  render() {
    return (
      <div id={'social-share'}>
        <div style={this.ulStyle} id={'share-links'}>
          {
            (this.state.showLinks)?
            <AnimateOnMount>
              <ul className="share-links-wrap">
                    <li onClick={this.toggleClick} className={'share-li'}>
                  <a className={'external-link'} target="_blank" href={'https://www.facebook.com/sharer.php?u=' + window.location.href}>Facebook</a>
                </li>
                    <li onClick={this.toggleClick} className={'share-li mid'}>
                  <a className={'external-link'} target="_blank" href={'http://twitter.com/share?text=' + this.description + '&url=' + window.location.href}>Twitter</a>
                </li>
                    <li onClick={this.toggleClick} className={'share-li'}>
                  <a className={'external-link'} target="_blank" href={'mailto:?subject=' + this.description + '&body=' + window.location.href}>Email</a>
                </li>
              </ul>
            </AnimateOnMount>
          :
              <div onClick={this.toggleClick} className={'share-title share-label external-link'}>Share</div>
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SocialShare.js